module.exports = __webpack_public_path__ + "img/Technischer_Zug_mit_FGr_Räumen.772275d3.svg";